import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const GraphBarIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.25 10C15.25 9.86193 15.3619 9.75 15.5 9.75H16.5C16.6381 9.75 16.75 9.86193 16.75 10V17.2504H15.25V10ZM15.5 8.25C14.5335 8.25 13.75 9.0335 13.75 10V18.0004C13.75 18.4146 14.0858 18.7504 14.5 18.7504H17.5C17.9142 18.7504 18.25 18.4146 18.25 18.0004V10C18.25 9.0335 17.4665 8.25 16.5 8.25H15.5ZM9.5 12.25C9.36193 12.25 9.25 12.3619 9.25 12.5V17.2504H10.75V12.5C10.75 12.3619 10.6381 12.25 10.5 12.25H9.5ZM7.75 12.5C7.75 11.5335 8.5335 10.75 9.5 10.75H10.5C11.4665 10.75 12.25 11.5335 12.25 12.5V18.0004C12.25 18.4146 11.9142 18.7504 11.5 18.7504H8.5C8.08579 18.7504 7.75 18.4146 7.75 18.0004V12.5ZM3.5 14.75C3.36193 14.75 3.25 14.8619 3.25 15V17.2504H4.75V15C4.75 14.8619 4.63807 14.75 4.5 14.75H3.5ZM1.75 15C1.75 14.0335 2.5335 13.25 3.5 13.25H4.5C5.4665 13.25 6.25 14.0335 6.25 15V18.0004C6.25 18.4146 5.91421 18.7504 5.5 18.7504H2.5C2.08579 18.7504 1.75 18.4146 1.75 18.0004V15Z"
        fill="currentColor"
      />
      <path
        d="M17.143 3.5265L14.6592 2.1735M17.143 3.5265L15.79 6.01033M17.143 3.5265L2.5 7.84224"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
